// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-icon-icon-oosMR {
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  box-sizing: content-box;
  transition: background-color 200ms;
}

.option-icon-icon-oosMR:hover {
  background-color: var(--hover-color);
}

.option-icon-icon-oosMR:active {
  background-color: var(--active-color);
}

.option-icon-disabled-_NCT6 {
  pointer-events: none;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/option-icon/option-icon.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".icon {\n  font-size: 24px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  box-sizing: content-box;\n  transition: background-color 200ms;\n}\n\n.icon:hover {\n  background-color: var(--hover-color);\n}\n\n.icon:active {\n  background-color: var(--active-color);\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `option-icon-icon-oosMR`,
	"disabled": `option-icon-disabled-_NCT6`
};
export default ___CSS_LOADER_EXPORT___;
